import React from 'react';

function PeriodSelector({ 
  selectedMonth, 
  selectedYear, 
  earliestAllowedDate, 
  onMonthSelect, 
  onYearChange, 
  actions
}) {
  const months = [
    "Januar", "Februar", "Marts", "April", "Maj", "Juni",
    "Juli", "August", "September", "Oktober", "November", "December"
  ];

  const handleMonthClick = (index) => {
    const monthNumber = index + 1;
    // Check om den valgte måned/år er før den tidligste tilladte dato
    if (earliestAllowedDate) {
      const isBeforeEarliest = selectedYear < earliestAllowedDate.year || 
        (selectedYear === earliestAllowedDate.year && monthNumber < earliestAllowedDate.month);
      
      if (isBeforeEarliest) {
        return;
      }
    }

    onMonthSelect(monthNumber);
  };

  const handlePreviousYear = () => {
    const newYear = Math.max(selectedYear - 1, earliestAllowedDate?.year || 2024);
    onYearChange(newYear);
  };

  const handleNextYear = () => {
    const newYear = selectedYear + 1;
    onYearChange(newYear);
  };

  return (
    <>
      <div className="year-navigation">
        <button 
          className="year-nav-btn"
          onClick={handlePreviousYear}
          disabled={selectedYear <= (earliestAllowedDate?.year || 2024)}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <span className="year-display">{selectedYear}</span>
        <button 
          className="year-nav-btn"
          onClick={handleNextYear}
          disabled={selectedYear >= new Date().getFullYear() + 1}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
        {actions && (
          <div className="year-actions">{actions}</div>
        )}
      </div>

      <div className="months-container">
        {months.map((month, index) => {
          const monthNumber = index + 1;
          const isDisabled = earliestAllowedDate && 
            (selectedYear < earliestAllowedDate.year || 
             (selectedYear === earliestAllowedDate.year && monthNumber < earliestAllowedDate.month));
          
          return (
            <div 
              key={monthNumber}
              className={`month-box ${monthNumber === selectedMonth ? 'active' : 'inactive'}`}
              onClick={() => {
                if (!isDisabled) {
                  handleMonthClick(index);
                }
              }}
              role="button"
              tabIndex={isDisabled ? -1 : 0}
              data-disabled={isDisabled}
            >
              {month}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PeriodSelector; 